import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "login"
};
var _hoisted_2 = {
  class: "login-actions"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_nav_bar = _resolveComponent("van-nav-bar");
  var _component_van_field = _resolveComponent("van-field");
  var _component_van_button = _resolveComponent("van-button");
  var _component_van_cell_group = _resolveComponent("van-cell-group");
  var _component_van_form = _resolveComponent("van-form");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_nav_bar, {
    title: "登录"
  }), _createVNode(_component_van_form, {
    onSubmit: $options.onSubmit
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_cell_group, {
        inset: ""
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_field, {
            modelValue: $data.phone,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return $data.phone = $event;
            }),
            name: "phone",
            type: "tel",
            label: "手机号",
            placeholder: "请输入手机号",
            clearable: "",
            required: ""
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            modelValue: $data.code,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return $data.code = $event;
            }),
            name: "code",
            label: "验证码",
            placeholder: "请输入验证码",
            clearable: "",
            required: ""
          }, {
            button: _withCtx(function () {
              return [_createVNode(_component_van_button, {
                size: "small",
                type: "primary",
                disabled: $data.sending,
                onClick: $options.onSendCode
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString($options.sendText), 1)];
                }),
                _: 1
              }, 8, ["disabled", "onClick"])];
            }),
            _: 1
          }, 8, ["modelValue"])];
        }),
        _: 1
      }), _createElementVNode("div", _hoisted_2, [_createVNode(_component_van_button, {
        type: "primary",
        block: "",
        "native-type": "submit"
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[2] || (_cache[2] = [_createTextVNode("登录", -1)]));
        }),
        _: 1
      })])];
    }),
    _: 1
  }, 8, ["onSubmit"])]);
}